import React from 'react';

const TapeLegal = ({ type }) => {
  const content = {
    privacy: {
      title: "Privacy Policy",
      sections: [
        {
          h: "1. Data Collection & Usage",
          p: "Tape collects audio recordings only when you explicitly start a recording session. This audio is processed to provide transcription, summaries, and AI-driven insights. We collect minimal personal information (email/name) solely for account management and cloud synchronization."
        },
        {
          h: "2. AI Data Handling & Privacy",
          p: "We use state-of-the-art AI models to process your meeting data. **Your data is NEVER used to train global AI models.** All processing is done via secure, private APIs where data is encrypted in transit and at rest. Audio files are processed ephemerally and are not stored by our AI providers for longer than necessary to provide the service."
        },
        {
          h: "3. Your Controls & Data Deletion",
          p: "You have full sovereignty over your data. Through the **Data & Privacy Controls** in your settings, you can:\n- Reset AI memory of your conversations.\n- Clear all meeting history and move it to Trash.\n- Permanently delete your account and all associated data from our servers."
        },
        {
          h: "4. Third-Party Service Providers",
          p: "We partner with industry leaders (Firebase for authentication/storage, AssemblyAI for transcription, Google Cloud for AI) to deliver our service. These providers are bound by strict confidentiality agreements and do not have permission to use your data for their own purposes."
        },
        {
          h: "5. Data Security",
          p: "We implement professional-grade security measures, including end-to-end encryption for cloud sync and biometric local locking (FaceID/TouchID), to protect your meeting documentation. However, you are responsible for maintaining the security of your account credentials."
        }
      ],
      updated: "May 10, 2026"
    },
    terms: {
      title: "Terms of Service",
      sections: [
        {
          h: "1. Acceptance of Terms & EULA",
          p: "By using Tape, you agree to these Terms and the Standard Apple End User License Agreement (EULA). If you do not agree, do not use the application."
        },
        {
          h: "2. Recording Consent & Responsibility",
          p: "You are solely responsible for obtaining explicit consent from all meeting participants before recording, as required by local and international laws. Tape is a tool for documentation and is not liable for unauthorized or illegal recordings."
        },
        {
          h: "3. Subscriptions & Billing",
          p: "Pro features require a paid subscription. All payments, renewals, and cancellations are handled exclusively through the Apple App Store. Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current period."
        },
        {
          h: "4. User Conduct",
          p: "You may not use Tape for any illegal purpose, to harass others, or to upload malicious content. We reserve the right to terminate accounts that violate these guidelines."
        },
        {
          h: "5. Limitation of Liability",
          p: "Tape is provided \"as is\". While we strive for 100% accuracy, we are not responsible for transcription errors, AI summary inaccuracies, or data loss. Use meeting insights as a secondary reference only."
        }
      ],
      updated: "May 10, 2026"
    },
    support: {
      title: "Tape Support",
      sections: [
        {
          h: "Contact Information",
          p: "Need help with Tape? Our team is here to ensure your meeting intelligence is always accurate and secure.\n\n- **Email:** contact@gurusworkshop.com\n- **Website:** gurusworkshop.com"
        },
        {
          h: "Frequently Asked Questions",
          p: "- **How do I delete my data?** You can clear your history or delete your account entirely from the \"Data & Privacy Controls\" within the app settings.\n- **Is my audio private?** Yes. Your data is encrypted and is never used to train global AI models.\n- **Can I use Tape on multiple devices?** Yes, simply sign in with the same account to sync your meeting vault across all your iOS devices."
        }
      ]
    }
  };

  const data = content[type] || content.privacy;

  return (
    <div className="section-padding" style={{ paddingTop: '100px' }}>
      <div className="container-custom">
        <div className="glass glass-card animate-fade-in" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 className="gradient-text" style={{ fontSize: '3rem', marginBottom: '2rem' }}>{data.title}</h1>
          
          {data.sections.map((section, index) => (
            <div key={index} style={{ marginBottom: '2.5rem' }}>
              <h3 style={{ color: 'var(--accent-color)', marginBottom: '1rem', fontSize: '1.5rem' }}>{section.h}</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', whiteSpace: 'pre-line' }}>
                {section.p}
              </p>
            </div>
          ))}

          {data.updated && (
            <p style={{ marginTop: '3rem', fontSize: '0.9rem', color: 'var(--text-secondary)', opacity: 0.6 }}>
              <strong>Last Updated:</strong> {data.updated}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TapeLegal;
